<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer">
      <v-list nav dense>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>General</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: `/rpcChecker` }">
              <v-list-item-title>RPC ノードの比較</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: `/bnbSender` }">
              <v-list-item-title>BNB の送付</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: `/createCustomTransaction` }">
              <v-list-item-title>カスタムトランザクションの作成</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: `/getCurrentBlockNumber` }">
              <v-list-item-title>現在のブロック番号の取得</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: `/transactionMonitor` }">
              <v-list-item-title>トランザクションの監視</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>PancakeRouterV2</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: `/swapExactETHForToken` }">
              <v-list-item-title>トークンの購入（直コン）</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: `/addLiquidityETHWatcher` }">
              <v-list-item-title>流動性追加の監視</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>DxSale</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: '/presaleContractChecker' }">
              <v-list-item-title>プリセールアドレスの確認</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/dxsaleListingMonitor' }">
              <v-list-item-title>リスティングの監視</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/dxsaleDisableWhitelistMonitor' }">
              <v-list-item-title>ホワイトリスト解除の監視</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <!--
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>ITAM のやつ</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: 'purchaseByITAM' }">
              <v-list-item-title>ITAM で買う</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        -->
        <!--
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Unicrypt</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: 'unicryptUserDeposit' }">
              <v-list-item-title>userDeposit</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        -->
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Unicrypt（V3）</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: 'unicryptV3UserDeposit' }">
              <v-list-item-title>userDeposit</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Unicrypt（V4）</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: '/unicryptV4approve' }">
              <v-list-item-title>approve</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/unicryptV4reserve' }">
              <v-list-item-title>reserve（old）</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/unicryptV4reserve2' }">
              <v-list-item-title>reserve</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/unicryptV4UserDeposit' }">
              <v-list-item-title>userDeposit（old）</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/unicryptV4UserDeposit2' }">
              <v-list-item-title>userDeposit</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>jojo</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <!--
            <v-list-item :to="{ path: 'jojoWatcher' }">
              <v-list-item-title>開始の監視</v-list-item-title>
            </v-list-item>
            -->
            <v-list-item :to="{ path: 'buyjojo' }">
              <v-list-item-title>買う</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <!--
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Binemon</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: 'binemonEgg' }">
              <v-list-item-title>卵買う</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        -->
        <!--
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Starmon</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: 'buyStarmon' }">
              <v-list-item-title>卵買う</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        -->
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>PinkSale</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: '/pinksale/presaleInfo' }">
              <v-list-item-title>Presale 情報の取得</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/pinksale/disableWhitelistMonitor' }">
              <v-list-item-title>ホワイトリスト解除の検出</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/pinksale/contribute' }">
              <v-list-item-title>買う</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Astronaut</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item-group>
            <v-list-item :to="{ path: '/astronaut/investing' }">
              <v-list-item-title>買う</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ path: '/astronaut/startastroshotroundmonitor' }">
              <v-list-item-title>AstroshotRound 開始の検出</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="#f3ba2f" dark app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>1919191919</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      drawer: null,
    };
  },
};
</script>
